<div class="header">
    <h2>{{ 'admins.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="admins-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'admins.fieldset.personal' | translate }}</h2>
        <div class="row">
            <app-form-input
                [control]="form.controls.firstName"
                [label]="'admins.form.firstName' | translate"
                [placeholder]="'admins.form.firstName.placeholder' | translate"
                inputId="firstName"
                testId="admins-add-first-name"
            />
            <app-form-input
                [control]="form.controls.lastName"
                [label]="'admins.form.lastName' | translate"
                [placeholder]="'admins.form.lastName.placeholder' | translate"
                inputId="lastName"
                testId="admins-add-last-name"
            />
        </div>
        <app-form-input
            [control]="form.controls.email"
            [label]="'admins.form.email' | translate"
            [placeholder]="'admins.form.email.placeholder' | translate"
            type="email"
            inputId="email"
            testId="admins-add-email"
        />
        <app-form-password
            [control]="form.controls.password"
            [label]="'admins.form.password' | translate"
            [placeholder]="'admins.form.password.placeholder' | translate"
            inputId="password"
            testId="admins-add-password"
        />
    </div>
</form>

<div class="footer">
    <p-button [label]="'admins.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="admins-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'admins.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="admins-add-submit"
        (onClick)="onSubmit()"
    />
</div>
